module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Author’s preface")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("I have set out to provide a ‘reader’s commentary’ on Isaiah – a companion to daily Bible reading – and I believe that those who use it this way will reap the largest rewards from it. This is not to say that it cannot be used to look up ‘spot’ verses or passages, for I have done my best not to evade difficulties and, in every such place, to ask what a reader, Bible in hand, would find most useful to know.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("In 1993 IVP were kind enough to publish my larger commentary, "), _c('i', [_vm._v("The Prophecy of Isaiah")]), _vm._v(", and it is only fair to say how this present work compares with that. First, I have felt comfortable in using again the structured outline of Isaiah which I worked out for the earlier book. Some reviewers criticized this or that aspect of my analysis, but, while I promise them that I have pondered what they wrote, they have not persuaded me to change my mind. Isaiah does not always stop to put down markers for us, and we come to his precious text to do the best we can. I do not see, for example, that I have opted for anything outrageous in dividing the book after chapter 37 rather than 39. R. E. Clements, whose approach to Isaiah is very far from mine, notes that ‘a redactor has quite consciously sought to use these narratives [i.e. chs. 36 – 39] to form a bridge between the “Assyrian” background of chs. 1 – 35 and the “Babylonian” background of chs. 40 – 66, with ch. 39 forming a key transition unit’ ("), _c('i', [_vm._v("Isaiah 1 – 39")]), _vm._v(", New Century Bible [Eerdmans/Marshalls, 1980], p. 277). I have simply made the ‘bridge’ into a ‘border-crossing’.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Secondly, the majority of the explanatory and expository work in this commentary is certainly new in expression and quite ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("considerably new in content. This is as it should be when we are dealing with the inexhaustible treasure of God’s Word. I have only very occasionally consciously quoted from "), _c('i', [_vm._v("The Prophecy of Isaiah")]), _vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("As ever, I owe a huge debt to Inter-Varsity Press and its ceaselessly kind director and editors. Even I cannot remember quite when it was that George Manley invited me to contribute an Isaiah commentary to the Tyndale series, so long ago is it! I was both surprised and delighted when, having presented them with the larger commentary (for which they had not asked!), and thinking that surely my chance with the Tyndale series (sadly, like much else in life) had been frittered away, Frank Entwistle renewed the invitation. He, like Ronald Inchley before him, has been a gracious and more than patient friend. It is in order to enhance my book that I dedicate it to these three, and to the present editor of the Tyndale Old Testament Commentaries, men to whom we owe so much.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Originally, the plan was for a two-volume commentary and, to my delight, Derek Kidner had responded positively to my desire to dedicate volume two to him. I am certainly not going to allow the absorption of volume two (Isa. 38 – 66) into volume one to deprive me of the pleasure and the honour of having his name associated with my book – even at the expense of overloading the now single dedicatory page! I count it a great privilege to forge this small link with one who is both a great friend and a far greater and more sensitive contributor than I to the art of Old Testament commentary.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("The completion of the Old Testament Tyndale series, begun with Derek Kidner’s delightful commentary on "), _c('i', [_vm._v("Proverbs ")]), _vm._v("in 1964, has been a long time coming and the fault is considerably mine. Just as God has been pleased to use individual volumes to his own glory in helping many readers to a fuller and deeper knowledge of his precious Word, may he now be pleased even more to use the completed series to that same supreme end!")])]), _c('p', {
    staticClass: "sign"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Alec Motyer"), _c('br'), _vm._v("Bishopsteignton, 1998")])])])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0